export const homeText = {
  spanish: {
    bannerText: "Las mejores líneas de productos del mercado.",
    offersText: "NOVEDADES Y PROMOCIONES",
    offersButton: "Ver todas las promociones",
    brandsText: "Marcas",
  },
  english: {
    bannerText: "The best product lines in the market.",
    offersText: "DEALS AND OFFERS",
    offersButton: "Check out our deals",
    brandsText: "Our brands",
  },
};

export const coreText = {
  spanish: {
    banner: {
      deals: "NOVEDADES Y PROMOCIONES",
      branchs: "SUCURSALES",
      login: "ACCESO A CLIENTES",
      searchBar: "Buscar en el catálogo",
    },
    menu: {
      search: "Buscar en el catálogo",
      category: "Categorías",
      solutions: "Soluciones PDI",
      brands: "Marcas",
      orders: "Lista Rápida",
      tracking: "Rastreo",
      promotions: "Promociones",
      branchOffice: "Sucursales",
      onlinesales: "Venta en Línea",
      list: "Listado",

      navmenu: [
        { name: "Categorías", href: "#/" },
        { name: "Soluciones PDI", href: "#/PDI" },
        { name: "Marcas", href: "#/brands" },
        { name: "Lista Rápida", href: "#/list" },
        // { name: "Rastreo", href: "http://acceso_cliente_tracking.risoul.com.mx/"},
        { name: "Rastreo", href: "#/tracking" },
        // { name: "Listado", href: "#"},
        // { name: "Buscar en la tienda", href: "#"},
        { name: "Promociones", href: "#/promo" },
        { name: "Sucursales", href: "https://www.risoul.com.mx/sucursales" },
        // { name: "Acceso a clientes", href: "#"}
      ],
    },
    footer: {
      menu: "MENÚ",
      blog: "BLOG",
      sales: "CONTAMOS CON 22 PUNTOS DE VENTA A NIVEL NACIONAL",
      newsletter: "BOLETÍN",
      newsletterText:
        "Únete y sigue nuestros artículos, promociones y novedades.",
      name: "Nombre",
      mail: "E-mail",
      button: "Suscribirme",
      follow: "SÍGUENOS",
      blogPosts: [
        {
          id: "1",
          title: "10 ventajas de utilizar gabinetes de la marca Hoffman",
          url: "https://www.risoul.com.mx/blog/10-ventajas-de-utilizar-gabinetes-de-la-marca-hoffman",
        },
        {
          id: "2",
          title: "4 modelos de cámaras termográficas Fluke",
          url: "https://www.risoul.com.mx/blog/4-modelos-de-camaras-termograficas-fluke",
        },
        {
          id: "3",
          title:
            "¿Cómo elegir el tipo de sensor Allen Bradley más adecuado para mi proyecto?",
          url: "https://www.risoul.com.mx/blog/como-elegir-el-tipo-de-sensor-allen-bradley-mas-adecuado-para-mi-proyecto",
        },
      ],
    },
  },
  english: {
    banner: {
      deals: "DEALS AND OFFERS",
      branchs: "BRANCHS",
      login: "LOG IN",
      searchBar: "Search in store",
    },
    menu: {
      search: "Search in store",
      category: "Categories",
      solutions: "PDI Solutions",
      brands: "Brands",
      orders: "Quick Orders",
      tracking: "Tracking",
      promotions: "Sales",
      branchOffice: "Branch Offices",
      onlinesales: "Online Sales",
      list: "Product List",
      brandItems: [
        "Automation",
        "Cables and Canalization",
        "Motion Control",
        "Distribution and Power",
        "Measurement",
        "Cranes and Cable Management",
        "Lighting",
        "Lamps and Ballasts",
        "Power Lines",
        "Lightning Rods and Ground",
        "Industrial Networks",
        "Safety and Industrial Boards",
        "Speed Variators",
        "Vision and Weighing",
      ],
      categories: [
        {
          name: "Automation",
          href: "#",
          items: [
            { name: "Programmable Controllers", href: "#" },
            { name: "HMI's", href: "#" },
            { name: "Input / Output Modules", href: "#" },
          ],
        },
        {
          name: "Cables and Canalization",
          href: "#",
          items: [
            { name: "Cables", href: "#" },
            { name: "Canalization", href: "#" },
            { name: "Connection devices", href: "#" },
            { name: "Cable management", href: "#" },
          ],
        },
        {
          name: "Control and Protection of Motors and Cranes",
          href: "#",
          items: [
            { name: "Push Buttons and Signaling", href: "#" },
            { name: "Motor Control", href: "#" },
            { name: "Drives and Motors", href: "#" },
            { name: "Relayers, Timers and Tablet Terminals", href: "#" },
          ],
        },
        {
          name: "Energy Quality and Distribution",
          href: "#",
          items: [
            { name: "Energy Quality", href: "#" },
            { name: "Electric Distribution", href: "#" },
          ],
        },
        {
          name: "Cabinets",
          href: "#",
          items: [{ name: "Cabinets", href: "#" }],
        },
        {
          name: "Tools and Measuring Instruments",
          href: "#",
          items: [{ name: "Instrumentos de Medición", href: "#" }],
        },
        {
          name: "Lighting and Controls",
          href: "#",
          items: [{ name: "Lighting", href: "#" }],
        },
        {
          name: "Sensors and Security",
          href: "#",
          items: [
            { name: "Security", href: "#" },
            { name: "Sensors", href: "#" },
          ],
        },
        {
          name: "Telecom",
          href: "#",
          items: [
            { name: "Unified Communications", href: "#" },
            { name: "Routing and Switching", href: "#" },
            { name: "Wireless", href: "#" },
          ],
        },
      ],
      navmenu: [
        { name: "Categories", href: "#" },
        { name: "PDI Solutions", href: "#" },
        { name: "Brands", href: "#" },
        { name: "Quick Orders", href: "#" },
        { name: "Tracking", href: "#" },
        { name: "Promotions", href: "#" },
        { name: "Product List", href: "#" },
        { name: "Search in store", href: "#" },
        { name: "Deals and offers", href: "#" },
        { name: "Branchs", href: "#" },
        { name: "LOG IN", href: "#" },
      ],
    },
    footer: {
      menu: "MENU",
      blog: "BLOG",
      sales: "WE HAVE 22 SALES LOCATIONS IN MEXICO",
      newsletter: "NEWSLETTER",
      newsletterText:
        "Join and follow our articles, promotions and latest news.",
      name: "Name",
      mail: "E-mail",
      button: "Subscribe",
      follow: "FOLLOW US",
      blogPosts: [
        {
          id: "1",
          title: "10 benefits of using Hoffman enclosures",
          url: "https://www.risoul.com.mx/blog/10-ventajas-de-utilizar-gabinetes-de-la-marca-hoffman",
        },
        {
          id: "2",
          title: "4 Fluke thermographic camera models",
          url: "https://www.risoul.com.mx/blog/4-modelos-de-camaras-termograficas-fluke",
        },
        {
          id: "3",
          title: "How to choose the best Allen Bradley sensor for your project",
          url: "https://www.risoul.com.mx/blog/como-elegir-el-tipo-de-sensor-allen-bradley-mas-adecuado-para-mi-proyecto",
        },
      ],
    },
  },
};
